<template>
  <div class="detail">
    <div class="content2">
      <div class="videoBox">
        <video
          ref="curVideo"
          class="video"
          width="100%"
          controls="controls"
          :src="videoUrl"
          muted
          preload="metadata"
        ></video>
        <!-- <div class="el-loading-mask" style="">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle
                cx="50"
                cy="50"
                r="20"
                fill="none"
                class="path"
              ></circle></svg
            >
          </div>
        </div> -->
      </div>
      <div class="episode">
        <div class="title">{{ title }}</div>
        <div class="nums">
          <span
            v-for="item in nums"
            :key="item"
            :class="num === item ? 'selected' : ''"
            @click="numsClick(item)"
          >
            {{ item }}
          </span>
        </div>
      </div>
    </div>
    <div class="content" style="clear: both; height: 700px">
      <div class="evaluate">
        <div class="title">精彩评论（{{ evaluateData.length }}）</div>
        <div v-for="item in evaluateData" :key="item.name" class="e-item">
          <div class="imgbox">
            <img :src="item.img" alt="" />
          </div>
          <div class="msgBox">
            <div class="name">{{ item.name }}</div>
            <div class="msg">{{ item.msg }}</div>
            <div class="time">{{ item.time }}</div>
          </div>
        </div>
      </div>
      <ranking-box :rankingList="rankingList"></ranking-box>
    </div>
  </div>
</template>

<script>
import RankingBox from "./Detail/RankingBox.vue";
import videos from "./ossVideo2";

export default {
  name: "Detail2",
  components: { RankingBox },
  data() {
    return {
      baseurl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video2/",
      videoUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video2/01.mp4",
      title: "熊猫博士和托托（二）",
      num: "01",
      evaluateData: [
        {
          img: "https://avatars.githubusercontent.com/u/8358236?s=40&v=4",
          name: "开心的豆豆妈妈",
          msg: "很喜欢，真的很适合孩子！",
          time: "昨日 12:31",
        },
        {
          img: "https://avatars.githubusercontent.com/u/5378891?s=40&v=4",
          name: "。不忘初心_ ",
          msg: "我最喜欢了，解放了家长。提升了孩子...",
          time: "2021-12-31 ",
        },
        {
          img: "https://avatars.githubusercontent.com/u/8186664?s=40&v=4",
          name: "吃名字真费劲",
          msg: "小时候自己能看到这个多好，只能给孩子看了，希望孩子能珍惜幸福！",
          time: "2021-12-30",
        },
        {
          img: "https://avatars.githubusercontent.com/u/29775873?s=40&v=4",
          name: "茉茉茉风吹雪香",
          msg: "太精彩了，看了片尾，觉的更精彩！",
          time: "2021-12-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/50612752?s=40&v=4",
          name: "白云浮云火烧云",
          msg: "推荐其他家长去看看，这真的不错，强烈推荐！",
          time: "2021-12-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/5526096?s=40&v=4",
          name: "ECHO爱吃荔枝",
          msg: "很好看啊，很有意义！施诗！",
          time: "2021-12-27",
        },
      ],
      videoHeight: "700px",
      rankingList: videos.puzzleRankingList
    };
  },
  computed: {
    nums: function () {
      let nums = 40;
      let data = [];
      for (let i = 1; i <= nums; i++) {
        if (i < 10) data.push("0" + i);
        else data.push("" + i);
      }
      return data;
    },
  },
  mounted() {
    this.getVideoInfo();
  },
  methods: {
    numsClick(num) {
      this.num = num;
      this.videoUrl = `${this.baseurl}${num}.mp4`;
      const _this = this;
      // 轮询视频时长，得到时长后清除定时器
      let hasDuration = setInterval(() => {
        let curVideoDuration = _this.$refs["curVideo"].duration;
        if (curVideoDuration) {
          // console.log("curVideoDuration", curVideoDuration);
          clearInterval(hasDuration);
        }
      }, 10);
    },
    rankingClick(url) {
      this.$router.push(url);
    },
    getVideoInfo() {
      const _this = this;
      setTimeout(() => {
        var box = document.getElementsByClassName("video");
        var videoH = box[0].clientHeight;
        _this.videoHeight = videoH + "px";
      }, 1000);
      window.onresize = function () {
        var box = document.getElementsByClassName("video");
        var videoH = box[0].clientHeight;
        _this.videoHeight = videoH + "px";
        console.log(_this.videoHeight)
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  padding: 110px 100px 20px;
  .content {
    position: relative;
    .videoBox {
      height: 100%;
      float: left;
      margin-right: 450px;
      position: relative;
      .video {
        height: 100%;
        width: 100%;
        display: block;
        object-fit: fill;
      }
      .el-loading-mask {
        position: absolute;
        z-index: 2000;
        background-color: rgba(0,0,0, 1);
        margin: 0;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transition: opacity .3s;
      }
    }
    .episode {
      overflow: scroll;
      width: 440px;
      padding: 20px;
      position: absolute;
      right: 0;
      top: 0;
      background-color: #222328;
      border-radius: 4px;
      .title {
        display: block;
        color: hsla(0, 0%, 100%, 0.9);
        line-height: 44px;
        font-size: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .nums {
        margin-top: 20px;
        margin-bottom: 14px;
        span {
          position: relative;
          float: left;
          width: 56px;
          height: 44px;
          line-height: 44px;
          border-radius: 4px;
          color: #ccc;
          font-size: 15px;
          font-family: Arial, PingFang SC, Microsoft Yahei;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        .selected,
        :hover {
          background-color: #1d2129;
          color: #00cc4c;
        }
      }
    }
    .evaluate {
      height: 100%;
      float: left;
      margin-right: 450px;
      padding: 30px 0;
      .title {
        height: 20px;
        font-size: 20px;
        line-height: 20px;
        color: #18191e;
        margin-bottom: 30px;
      }
      .e-item {
        display: flex;
        margin-bottom: 20px;
        .imgbox {
          width: 54px;
          height: 54px;
          margin-right: 16px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .msgBox {
          .name {
            font-size: 15px;
            color: #18191e;
            opacity: 0.6;
            filter: alpha(opacity=60);
            transition: color 0.2s;
            margin-bottom: 7px;
          }
          .msg {
            margin-bottom: 5px;
            font-size: 15px;
            line-height: 27px;
            word-wrap: break-word;
          }
          .time {
            margin-right: 40px;
            font-size: 13px;
            color: #18191e;
            opacity: 0.6;
            filter: alpha(opacity=60);
          }
        }
      }
    }
    .ranking {
      height: 100%;
      width: 450px;
      padding: 20px;
      position: absolute;
      right: 0;
      top: 0;
      .title {
        vertical-align: top;
        letter-spacing: 0;
        font-size: 24px;
        color: #18191e;
        margin-bottom: 20px;
      }
      .r-item {
        font-size: 18px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
      }
    }
  }
  .content2{
    width: 100%;
    position: relative;
    display: flex;
    .videoBox{
      flex:1;
      margin-right: 10px;
      .video {
        height: 100%;
        width: 100%;
        display: block;
        object-fit: fill;
      }
    }
    .episode{
      overflow: scroll;
      width: 440px;
      padding: 20px;
      background-color: #222328;
      border-radius: 4px;
      .title {
        display: block;
        color: hsla(0, 0%, 100%, 0.9);
        line-height: 44px;
        font-size: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .nums {
        margin-top: 20px;
        margin-bottom: 14px;
        span {
          position: relative;
          float: left;
          width: 56px;
          height: 44px;
          line-height: 44px;
          border-radius: 4px;
          color: #ccc;
          font-size: 15px;
          font-family: Arial, PingFang SC, Microsoft Yahei;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        .selected,
        :hover {
          background-color: #1d2129;
          color: #00cc4c;
        }
      }
    }
  }
}
</style>


